import { Navbar, Container } from "react-bootstrap"


function navbar(props){
    return (
        <Navbar>
                <Navbar.Brand>Connect 4</Navbar.Brand>
        </Navbar>
    )
}

export default navbar;